
import Logo from "../components/Logo"
import MenuIcon from "../components/Svg/MenuIcon"

function MobileHeader(props) {
 
  return (
    <div className={props.className}>
        <Logo />
        <div className="menu-group" onClick={props.onClick}>
       <MenuIcon className="menu-icon" fill='#7A8996'/>
       </div>
    </div>
  )
}

export default MobileHeader